import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, Input, Select, Toast, Popconfirm, InputNumber, Form } from '@douyinfe/semi-ui';
import { IconEdit, IconDelete, IconPlus, IconSearch } from '@douyinfe/semi-icons';
import request from '../../utils/request';
import styles from './index.module.scss';
import ImageSelector from '../../components/ImageSelector';
import MapPicker from '../../components/MapPicker';
import RegionSelector from '../../components/RegionSelector';

const Stores = () => {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10, total: 0 });
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [currentRecord, setCurrentRecord] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [searchStatus, setSearchStatus] = useState(null);
    const [formApi, setFormApi] = useState(null);

    const statusMap = {
        0: { text: '正常营业', type: 'success' },
        1: { text: '隐藏', type: 'warning' },
        2: { text: '打烊', type: 'danger' },
    };

    const fetchList = async (page = 1, limit = 10) => {
        setLoading(true);
        try {
            const response = await request.get('/go/sp/shop/list_store/', {
                params: {
                    page: page - 1,
                    limit,
                    key: searchKey,
                    status: searchStatus === null ? -1 : searchStatus
                }
            });
            if (response.errno === 0) {
                setDataSource(response.list || []);
                setPagination(prev => ({
                    ...prev,
                    currentPage: page,
                    total: response.total_cnt
                }));
            } else {
                Toast.error(response.errstr || '获取列表失败');
            }
        } catch (error) {
            console.error('获取列表失败:', error);
            Toast.error('获取列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleAdd = async (values) => {
        try {
            // 转换经纬度为字符串
            const processedValues = {
                ...values,
                lat: String(currentRecord.lat),
                lng: String(currentRecord.lng)
            };
            console.log(values, " aaaaaaddddddd ", processedValues, currentRecord, formApi?.getValues())
            const response = await request.post('/go/sp/shop/add_store/', processedValues);
            if (response.errno === 0) {
                Toast.success('添加成功');
                setShowAddModal(false);
                fetchList();
            } else {
                Toast.error(response.errstr || '添加失败');
            }
        } catch (error) {
            console.error('添加失败:', error);
            Toast.error('添加失败');
        }
    };

    const handleEdit = async (values) => {
        try {
            // 转换经纬度为字符串
            const processedValues = {
                ...values,
                uid: currentRecord.uid,
                //lat: String(values.lat),
                //lng: String(values.lng)
                lat: String(currentRecord.lat),
                lng: String(currentRecord.lng)
            };
            console.log(values, "ffffff", processedValues, "ccccc", currentRecord)
            const response = await request.post('/go/sp/shop/edit_store/', processedValues);
            if (response.errno === 0) {
                Toast.success('编辑成功');
                setShowEditModal(false);
                fetchList();
            } else {
                Toast.error(response.errstr || '编辑失败');
            }
        } catch (error) {
            console.error('编辑失败:', error);
            Toast.error('编辑失败');
        }
    };

    const handleDelete = async (uids) => {
        try {
            const response = await request.post('/go/sp/shop/delete_store/', {
                uids: Array.isArray(uids) ? uids.join(',') : uids
            });
            if (response.errno === 0) {
                Toast.success('删除成功');
                setSelectedRowKeys([]);
                fetchList();
            } else {
                Toast.error(response.errstr || '删除失败');
            }
        } catch (error) {
            console.error('删除失败:', error);
            Toast.error('删除失败');
        }
    };

    const handleBatchEdit = async (status, uids) => {
        if (!uids || (Array.isArray(uids) && !uids.length)) {
            Toast.warning('请选择要操作的门店');
            return;
        }
        try {
            const response = await request.post('/go/sp/shop/batchedit_store/', {
                uids: Array.isArray(uids) ? uids.join(',') : uids,
                status
            });
            if (response.errno === 0) {
                Toast.success('操作成功');
                setSelectedRowKeys([]);
                fetchList();
            } else {
                Toast.error(response.errstr || '操作失败');
            }
        } catch (error) {
            console.error('操作失败:', error);
            Toast.error('操作失败');
        }
    };

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const columns = [
        {
            title: '门店信息',
            dataIndex: 'title',
            width: 300,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    {record.image && <img src={record.image} alt={text} style={{ width: 40, height: 40, borderRadius: 4 }} />}
                    <div style={{ fontSize: '12px' }}>
                        <div style={{ color: 'var(--semi-color-text-0)', marginBottom: '4px' }}>{text}</div>
                        <div style={{ color: 'var(--semi-color-text-2)' }}>{record.address}</div>
                    </div>
                </div>
            )
        },
        {
            title: '联系人',
            dataIndex: 'contact_name',
            width: 200,
            render: (text, record) => (
                <div style={{ fontSize: '12px' }}>
                    <div>{text}</div>
                    <div style={{ color: 'var(--semi-color-text-2)' }}>{record.contact_phone}</div>
                </div>
            )
        },
        {
            title: '状态',
            dataIndex: 'status',
            width: 120,
            render: (text) => {
                const status = statusMap[text] || { text: '异常', type: 'danger' };
                return <Button theme='light' type={status.type} size='small'>{status.text}</Button>;
            }
        },
        {
            title: '排序',
            dataIndex: 'sort',
            width: 100,
        },
        {
            title: '创建时间/更新时间',
            dataIndex: 'update_time',
            width: 180,
            render: (text, record) => (
                <div style={{ fontSize: '12px', color: 'var(--semi-color-text-2)' }}>
                    <div>{formatTimestamp(record.create_time)}</div>
                    <div>{formatTimestamp(text)}</div>
                </div>
            )
        },
        {
            title: '操作',
            dataIndex: 'operate',
            width: 160,
            render: (_, record) => (
                <Space>
                    <Button
                        theme='light'
                        type='primary'
                        icon={<IconEdit />}
                        onClick={() => {
                            setCurrentRecord({
                                ...record,
                                lat: parseFloat(record.lat),
                                lng: parseFloat(record.lng)
                            });
                            setShowEditModal(true);
                        }}
                    >
                        编辑
                    </Button>
                    <Popconfirm
                        title="确定要删除吗？"
                        content="此操作不可恢复"
                        onConfirm={() => handleDelete(record.uid)}
                    >
                        <Button theme='light' type='danger' icon={<IconDelete />}>删除</Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    const renderForm = () => {
        const initValues = currentRecord || {};
        return (
            <Form
                getFormApi={setFormApi}
                initValues={{ ...initValues, status: 0 }}
                onSubmit={showEditModal ? handleEdit : handleAdd}
            >
                <ImageSelector
                    field="image"
                    label="门店主图"
                    value={initValues.image}
                    onChange={(value) => formApi.setValue('image', value)}
                />
                <Form.Input
                    field="title"
                    label="门店名称"
                    rules={[{ required: true, message: '请输入门店名称' }]}
                />
                <Form.Select
                    field="status"
                    label="状态"
                    rules={[{ required: true, message: '请选择状态' }]}
                >
                    {Object.entries(statusMap).map(([value, { text }]) => (
                        <Form.Select.Option key={value} value={parseInt(value)}>{text}</Form.Select.Option>
                    ))}
                </Form.Select>
                <Form.InputNumber
                    field="sort"
                    label="排序"
                />
                <Form.Input
                    field="contact_name"
                    label="联系人"
                />
                <Form.Input
                    field="contact_phone"
                    label="联系电话"
                />
                <RegionSelector
                    field="region"
                    label="所在地区"
                    initValue={currentRecord ? [currentRecord.province, currentRecord.city, currentRecord.town] : undefined}
                    onChange={(value) => {
                        if (value && value.length === 3) {
                            formApi?.setValue('province', value[0]);
                            formApi?.setValue('city', value[1]);
                            formApi?.setValue('town', value[2]);
                        }
                    }}
                />
                <Form.Input
                    field="address"
                    label="详细地址"
                />
                <MapPicker
                    field="location"
                    label="地理位置"
                    initialPosition={currentRecord ? [parseFloat(currentRecord.lng) || 0, parseFloat(currentRecord.lat) || 0] : undefined}
                    onChange={(location) => {
                        location.address = location.address || '';
                        const addressComponents = location.address.match(/(.*?[省市区县])(.*?[市州])(.*?[区县])?(.*)/) || [];
                        const [_, province = '', city = '', district = '', address = ''] = addressComponents;
                        formApi?.setValue('province', province);
                        formApi?.setValue('city', city);
                        formApi?.setValue('town', district);
                        formApi?.setValue('address', address.replace(/^\s+/, ''));
                        formApi?.setValue('lat', parseFloat(location.lat));
                        formApi?.setValue('lng', parseFloat(location.lng));
                        formApi?.setValue('location', (location));
                        if (currentRecord) {
                            currentRecord.lat = location.lat;
                            currentRecord.lng = location.lng;
                        }
                        console.log('onSelect触发', {
                            lat: location.lat,
                            lng: location.lng,
                            fullLocation: location
                        }, 'fff', formApi?.getValues())
                    }}
                />
            </Form>
        );
    };

    return (
        <div className={styles.storesContainer}>
            <div className={styles.header}>
                <Space>
                    <Input
                        prefix={<IconSearch />}
                        placeholder="搜索门店名称"
                        value={searchKey}
                        onChange={setSearchKey}
                        onEnterPress={() => fetchList()}
                    />
                    <Select
                        placeholder="状态筛选"
                        value={searchStatus}
                        onChange={setSearchStatus}
                        style={{ width: 120 }}
                    >
                        <Select.Option value={null}>全部</Select.Option>
                        {Object.entries(statusMap).map(([value, { text }]) => (
                            <Select.Option key={value} value={parseInt(value)}>{text}</Select.Option>
                        ))}
                    </Select>
                    <Button type="primary" onClick={() => fetchList()}>搜索</Button>
                    <Button type="primary" icon={<IconPlus />} onClick={() => setShowAddModal(true)}>新增门店</Button>
                </Space>
            </div>

            {selectedRowKeys.length > 0 && (
                <div className={styles.actionButtons}>
                    <Space>
                        <Button type="primary" onClick={() => handleBatchEdit(0, selectedRowKeys)}>批量上架</Button>
                        <Button type="warning" onClick={() => handleBatchEdit(1, selectedRowKeys)}>批量隐藏</Button>
                        <Button type="danger" onClick={() => handleBatchEdit(2, selectedRowKeys)}>批量打烊</Button>
                        <Popconfirm
                            title="确定要删除选中的门店吗？"
                            content="此操作不可恢复"
                            onConfirm={() => handleDelete(selectedRowKeys)}
                        >
                            <Button type="danger">批量删除</Button>
                        </Popconfirm>
                    </Space>
                </div>
            )}

            <Table
                loading={loading}
                dataSource={dataSource}
                columns={columns}
                pagination={{
                    currentPage: pagination.currentPage,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    onPageChange: (page) => fetchList(page, pagination.pageSize)
                }}
                rowKey="uid"
                rowSelection={{
                    selectedRowKeys,
                    onChange: setSelectedRowKeys
                }}
            />

            <Modal
                title="新增门店"
                visible={showAddModal}
                onOk={() => formApi?.submitForm()}
                onCancel={() => setShowAddModal(false)}
                width={600}
                maskClosable={false}
            >
                {renderForm()}
            </Modal>

            <Modal
                title="编辑门店"
                visible={showEditModal}
                onOk={() => formApi?.submitForm()}
                onCancel={() => setShowEditModal(false)}
                width={600}
                maskClosable={false}
            >
                {renderForm()}
            </Modal>
        </div>
    );
};

export default Stores;